import { forwardRef } from 'react';
import Link from '@mui/material/Link';
import Box, { BoxProps } from '@mui/material/Box';
import { RouterLink } from 'src/routes/components';
import { useSettingsContext } from '../settings';
import { landingUrl } from 'src/config-global';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  iconOnly?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, iconOnly = false, sx, ...other }, ref) => {
    const settings = useSettingsContext();

    const isMini = settings.themeLayout === 'mini' || iconOnly;
    const logoUrl = isMini ? '/logo/logo_single.png' : '/logo/logo_full.png';
    const logoWidth = isMini ? 40 : 170;

    const logo = (
      <Box
        component="img"
        src={logoUrl}
        sx={{ width: logoWidth, height: 40, cursor: 'pointer', ...sx }}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href={landingUrl} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

export default Logo;
